import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconEdit from '@/icons/Edit.svg';
import { ArticleWithRelations } from '@/models/request';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { BaseMessage } from './BaseMessage';

export const AddCustomsInformationsTaskMessage = ({
  article,
}: {
  article: ArticleWithRelations;
}) => {
  const { state } = useArticleContext();

  return (
    <BaseMessage
      title={
        <Trans id="article.task.add_customs_informations.title">
          Provide the required customs information
        </Trans>
      }
      message={
        <Stack gap="0.25rem" style={{ flex: 1 }}>
          <Paragraph>
            <Trans id="article.task.add_customs_informations.message">
              The item cannot be shipped without customs information due to the destination country.
              Please provide the required information.
            </Trans>
          </Paragraph>
          <div>
            <Button variant="secondary" onPress={() => state.customsPanel.setIsOpen(true)}>
              <IconEdit />
              <Trans id="article.customs.missing-info.action">Edit customs information</Trans>
            </Button>
          </div>
        </Stack>
      }
      article={article}
    />
  );
};
